<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="country"
								width="90"
                                :show-overflow-tooltip="true"
                                label="国家名称">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
								min-width="140"
                                :show-overflow-tooltip="true"
                                label="型号">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.proModel}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
								width="120"
                                :show-overflow-tooltip="true"
                                label="产品编码">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
								width="90"
                                label="型号属性"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
								width="60"
                                :show-overflow-tooltip="true"
                                label="数量">	
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.proNumber}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
								width="120"
                                :show-overflow-tooltip="true"
                                label="使用库存数量">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.useInventory}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="isSpecific"
								width="110"
                                :show-overflow-tooltip="true"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
								min-width="140"
                                :show-overflow-tooltip="true"
                                label="改制需求描述">
									<template slot-scope="scope">
									    <div style="text-align: left;">
									        {{scope.row.specificReq}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="remark"
								min-width="140"
                                :show-overflow-tooltip="true"
                                label="备注">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.remark}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
								width="110"
                                :show-overflow-tooltip="true"
                                label="预计交货期">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- <div class="h-pagination2 h-pageCenter" style="margin-top:20px;">
                <pagination :page="q" @query="query"/>
            </div> -->
            <div class="h-table h-mrt30 h-rowBox" v-if="showText">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="formLabelAlign" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                      style="margin:30px 0 40px 29px">
                            <el-input v-model="shenhetext" placeholder="请输入"
                                      class="zidaoO"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="apprButton">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
				<el-button v-if="showrefuse" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
				<el-button v-if="showpass" class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                tableData: [],
                formLabelAlign:{},
                shenhetext:'',
                instid: '',
                showhistory: false,
                showrefuse: false,
                showpass: false,
                showText: false,
                table: {
                    data: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                q: {
                    bid: '',
                },
            }
        },
        mounted() {

        },
        created() {
            this.table.taskId = this.$route.query.taskid;
            this.table.instId = this.$route.query.instid;
            this.instid = this.$route.query.instid;
            if (this.$route.query.taskstatus == 0) {
                this.showrefuse = true;
                this.showpass = true;
                this.showText = true;
            }
            this.query();
        },
        methods: {
            //查看审批流详情
            findDetail(){
                this.showhistory = true;
            },
            query() {
                this.q.bid = this.$route.query.ywid;
                ss.waixiao.showDZSPList(this.q).then(rd => {
                    this.tableData = rd;
                })
            },
            auditPass() {
                this.table.aaa = 2
                this.table.optflag = '审核通过';
                this.table.yijianMsg = this.shenhetext;
                this.table.data = this.tableData;
                ss.waixiao.shTG(this.table).then(rd => {
                    if (rd.f == true) {
                        this.$msg.msgs(rd.msg);
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({path:'/personal/dealCenter'})
                    } else {
                        this.$msg.msge(rd.msg);
                    }
                })
            },
            auditFail() {
                var reg = /^\s$/;
                if (reg.test(this.shenhetext)) {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                if (this.shenhetext == "") {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                this.table.aaa = 1
                this.table.optflag = '审核被驳回';
                this.table.yijianMsg = this.shenhetext;
                this.table.data = this.tableData;
                ss.waixiao.shBTG(this.table).then(rd => {
                    if (rd.f == true) {
                        this.$msg.msgs(rd.msg);
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({path:'/personal/dealCenter'})
                    } else {
                        this.$msg.msge(rd.msg);
                    }
                })
            },
            returnTable() {
                // this.$router.go(-1);
                this.$router.push({path: '/personal/dealCenter'})
            }
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
    }
    .apprButton {
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	width: 100%;
        padding: 0.3rem 0;
    }
    .cancel {
        width: 18%;
    }
    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
    /*--------------- 审批样式 ------------------*/
</style>